import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { BookOpenIcon, WindIcon, ZapIcon, ShoppingCartIcon, ShieldIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
const deliverables = [{
  icon: BookOpenIcon,
  title: 'El Manual del Reset de 72 Horas',
  description: 'La guía paso a paso para ejecutar el vaciado químico de viernes a lunes.'
}, {
  icon: WindIcon,
  title: 'Protocolo SOS de 120 Segundos',
  description: 'La técnica de respiración neurobiológica para bajar las pulsaciones en plena crisis.'
}, {
  icon: ZapIcon,
  title: 'Mapa de Fugas Energéticas',
  description: 'La herramienta para identificar qué apps y personas te están robando la batería mental.'
}, {
  icon: ShoppingCartIcon,
  title: 'Lista de Supermercado "Anti-Pánico"',
  description: 'Qué comer (y qué evitar) para que tu glucosa no dispare tu ansiedad.'
}, {
  icon: ShieldIcon,
  title: 'Plan de Blindaje del Lunes',
  description: 'Cómo configurar tu mañana para que nadie rompa tu paz antes de las 11 AM.'
}];
export function WhatYouGetSection() {
  return <section className="py-24 px-6 bg-charcoal-900" data-id="element-180">
      <div className="max-w-5xl mx-auto" data-id="element-181">
        <FadeIn data-id="element-182">
          <div className="mb-20 text-center" data-id="element-183">
            <div className="inline-flex items-center gap-3 bg-mutedred/10 border border-mutedred/30 px-5 py-2.5 rounded-full mb-6" data-id="element-184">
              <span className="w-2.5 h-2.5 rounded-full bg-mutedred animate-pulse" data-id="element-185"></span>
              <span className="text-mutedred text-sm font-medium tracking-wide" data-id="element-186">
                ⏰ Este precio cierra el domingo a las 23:59. Después sube a
                $19.990.
              </span>
            </div>

            <div className="flex flex-col items-center mb-6" data-id="element-187">
              <span className="block text-offwhite/60 text-sm uppercase tracking-widest mb-2" data-id="element-188">
                Acceso inmediato por solo
              </span>
              <span className="font-heading text-6xl sm:text-7xl text-amber drop-shadow-[0_0_15px_rgba(212,168,83,0.3)] mb-3 block" data-id="element-189">
                $9.990
              </span>
              <span className="text-offwhite/80 text-lg font-light" data-id="element-190">
                o{' '}
                <strong className="text-offwhite font-medium" data-id="element-191">
                  3 cuotas sin interés de $3.330
                </strong>
              </span>
            </div>

            <p className="text-mutedteal text-sm font-medium mb-6" data-id="element-192">
              🔥 Más de 500 personas ya aplicaron este protocolo este fin de
              semana.
            </p>

            <CTAButton className="w-full max-w-xl mb-4" data-id="element-193">
              SÍ, QUIERO RECUPERAR MI DOMINGO
            </CTAButton>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-offwhite/60 text-sm mt-4" data-id="element-194">
              <span className="flex items-center gap-2" data-id="element-195">
                <ShieldCheckIcon className="w-4 h-4 text-mutedteal" data-id="element-196" /> Pago 100%
                seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-197">
                <ZapIcon className="w-4 h-4 text-amber" data-id="element-198" /> Descarga instantánea
              </span>
              <span className="flex items-center gap-2" data-id="element-199">
                <ClockIcon className="w-4 h-4 text-mutedteal" data-id="element-200" /> Acceso de por
                vida
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn data-id="element-201">
          <h2 className="font-heading text-4xl sm:text-5xl text-offwhite mb-16 text-center" data-id="element-202">
            Lo que obtenés hoy
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-203">
          {deliverables.map((item, index) => {
          const Icon = item.icon;
          return <FadeIn key={index} delay={0.1 * index} className={index === 4 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-204">
                <div className="bg-charcoal-800 p-8 rounded-sm border border-charcoal-700 h-full hover:border-amber/30 transition-colors" data-id="element-205">
                  <div className="w-12 h-12 bg-amber/10 rounded-full flex items-center justify-center mb-6" data-id="element-206">
                    <Icon className="w-6 h-6 text-amber" data-id="element-207" />
                  </div>
                  <h3 className="text-xl font-semibold text-offwhite mb-3" data-id="element-208">
                    {item.title}
                  </h3>
                  <p className="text-offwhite/70 leading-relaxed font-light" data-id="element-209">
                    {item.description}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}